export const scoreColor = (v) => {
  if (v == null) return "#71717A";
  if (v < 50) return "#FF3B30";
  if (v < 80) return "#FFD60A";
  return "#32D74B";
};

export default function ScoreGauge({ value = 0, size = 88, stroke = 8, label }) {
  const radius = (size - stroke) / 2;
  const circ = 2 * Math.PI * radius;
  const pct = Math.max(0, Math.min(100, value || 0));
  const offset = circ - (pct / 100) * circ;
  const color = scoreColor(value);

  return (
    <div className="flex flex-col items-center gap-2" data-testid="score-gauge">
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="#1f1f1f" strokeWidth={stroke} />
          <circle
            cx={size / 2} cy={size / 2} r={radius} fill="none" stroke={color} strokeWidth={stroke}
            strokeDasharray={circ} strokeDashoffset={offset} strokeLinecap="round"
            style={{ transition: "stroke-dashoffset 0.8s ease, stroke 0.4s ease" }}
          />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="font-heading font-bold text-white" style={{ fontSize: size * 0.26 }}>
            {value != null ? value : "--"}
          </span>
        </div>
      </div>
      {label && (
        <span className="text-[10px] font-bold uppercase tracking-[0.15em] text-zinc-500">{label}</span>
      )}
    </div>
  );
}
